import { render } from "./EnDashboardIconWrapper.vue?vue&type=template&id=b74707fe&scoped=true"
import script from "./EnDashboardIconWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./EnDashboardIconWrapper.vue?vue&type=script&setup=true&lang=js"

import "./EnDashboardIconWrapper.vue?vue&type=style&index=0&id=b74707fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74707fe"],['__file',"Shared/components/icons/EnDashboardIconWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b74707fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b74707fe', __exports__)) {
    api.reload('b74707fe', __exports__)
  }
  
  module.hot.accept("./EnDashboardIconWrapper.vue?vue&type=template&id=b74707fe&scoped=true", () => {
    api.rerender('b74707fe', render)
  })

}


export default __exports__